/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ScorecardMarker
 */
export interface ScorecardMarker {
    /**
     * 
     * @type {string}
     * @memberof ScorecardMarker
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScorecardMarker
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ScorecardMarker
     */
    startOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardMarker
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardMarker
     */
    utteranceId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardMarker
     */
    sentenceId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardMarker
     */
    endOffset?: number;
}

/**
 * Check if a given object implements the ScorecardMarker interface.
 */
export function instanceOfScorecardMarker(value: object): boolean {
    return true;
}

export function ScorecardMarkerFromJSON(json: any): ScorecardMarker {
    return ScorecardMarkerFromJSONTyped(json, false);
}

export function ScorecardMarkerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardMarker {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'startOffset': json['startOffset'] == null ? undefined : json['startOffset'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'sentenceId': json['sentenceId'] == null ? undefined : json['sentenceId'],
        'endOffset': json['endOffset'] == null ? undefined : json['endOffset'],
    };
}

export function ScorecardMarkerToJSON(value?: ScorecardMarker | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'startOffset': value['startOffset'],
        'contactId': value['contactId'],
        'utteranceId': value['utteranceId'],
        'sentenceId': value['sentenceId'],
        'endOffset': value['endOffset'],
    };
}

